export default "__VITE_ASSET__370ab9f3__"